import { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import GET_SUBMISSION_STATUS_BY_CASE from '../../graphql/getSubmissionStatusByCase';
import { INVENTORY_REQUEST_DETAIL_UI } from '../constants';
import { isRecentSubmission, isSubmissionInFlight } from '../submissionStatus';
import { submissionPolling } from '../../store/submissionPolling';

/**
 * Picks up a submission that is still in flight when a screen loads, so a reopened or reloaded
 * record keeps following it. Only recent in-flight submissions are resumed; the store is not
 * persisted, so this lookup is the only way a reload learns about one.
 */
const useSubmissionRecovery = (caseExternalId: string | null | undefined): void => {
  const { data } = useQuery(GET_SUBMISSION_STATUS_BY_CASE, {
    fetchPolicy: 'no-cache',
    skip: !caseExternalId,
    variables: {
      caseExternalId,
    },
  });

  useEffect(() => {
    const byCaseStatus = data?.getSubmissionStatusByCase;

    if (!caseExternalId || !byCaseStatus?.submissionId) {
      return;
    }

    const isRecentInFlight =
      isSubmissionInFlight(byCaseStatus) &&
      isRecentSubmission(byCaseStatus, INVENTORY_REQUEST_DETAIL_UI.SUBMISSION_RECOVERY_MAX_AGE_MS);

    if (isRecentInFlight) {
      submissionPolling.hydrateSubmissionStatus(caseExternalId, byCaseStatus);
    }
  }, [caseExternalId, data]);
};

export default useSubmissionRecovery;
